// Generated types for PhysicsPort
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EffortVariable, FlowVariable, PhysicsDomain } from '../enums';

import { PortReadAPI, PortWriteAPI } from './port';
import { PortReadAPISchemaObject, PortWriteAPISchemaObject } from './port';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PhysicsPortReadAPI extends PortReadAPI {
  /** Physics domain (electrical / mech_trans / hydraulic / thermal / ...). */
  domain: PhysicsDomain;
  /** Effort variable (voltage / force / pressure / ...). Auto-filled from `domain` at flush time if omitted: ELECTRICAL→VOLTAGE, MECH_ROT→TORQUE, HYDRAULIC→PRESSURE, etc. Override only for unusual cases. */
  effort_var?: EffortVariable | null;
  /** Flow variable (current / velocity / volumetric / ...). Auto-filled from `domain` at flush time if omitted: ELECTRICAL→CURRENT, MECH_ROT→ANGULAR_VEL, HYDRAULIC→VOLUMETRIC, etc. */
  flow_var?: FlowVariable | null;
  nominal_effort?: number | null;
  nominal_flow?: number | null;
  /** SI unit string e.g. 'V', 'Nm', 'Pa'. */
  effort_unit?: string | null;
  /** SI unit string e.g. 'A', 'm/s', 'm^3/s'. */
  flow_unit?: string | null;
  max_effort?: number | null;
  max_flow?: number | null;
}

export interface PhysicsPortWriteAPI extends PortWriteAPI {
  /** Physics domain (electrical / mech_trans / hydraulic / thermal / ...). */
  domain: PhysicsDomain;
  /** Effort variable (voltage / force / pressure / ...). Auto-filled from `domain` at flush time if omitted: ELECTRICAL→VOLTAGE, MECH_ROT→TORQUE, HYDRAULIC→PRESSURE, etc. Override only for unusual cases. */
  effort_var?: EffortVariable | null;
  /** Flow variable (current / velocity / volumetric / ...). Auto-filled from `domain` at flush time if omitted: ELECTRICAL→CURRENT, MECH_ROT→ANGULAR_VEL, HYDRAULIC→VOLUMETRIC, etc. */
  flow_var?: FlowVariable | null;
  nominal_effort?: number | null;
  nominal_flow?: number | null;
  /** SI unit string e.g. 'V', 'Nm', 'Pa'. */
  effort_unit?: string | null;
  /** SI unit string e.g. 'A', 'm/s', 'm^3/s'. */
  flow_unit?: string | null;
  max_effort?: number | null;
  max_flow?: number | null;
  /** The LogicalPart that owns this PhysicsPort. */
  owner?: string;
  /** Ancestor LPs that surface this port (composite parents in the parent chain). */
  bound_to?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PhysicsPortReadAPISchema: z.ZodType<PhysicsPortReadAPI> = PortReadAPISchemaObject.extend({
  domain: z.nativeEnum(PhysicsDomain),
  effort_var: z.nativeEnum(EffortVariable).nullable().optional(),
  flow_var: z.nativeEnum(FlowVariable).nullable().optional(),
  nominal_effort: z.number().nullable().optional(),
  nominal_flow: z.number().nullable().optional(),
  effort_unit: z.string().nullable().optional(),
  flow_unit: z.string().nullable().optional(),
  max_effort: z.number().nullable().optional(),
  max_flow: z.number().nullable().optional(),
}).passthrough();

export const PhysicsPortWriteAPISchema: z.ZodType<PhysicsPortWriteAPI> = PortWriteAPISchemaObject.extend({
  domain: z.nativeEnum(PhysicsDomain),
  effort_var: z.nativeEnum(EffortVariable).nullable().optional(),
  flow_var: z.nativeEnum(FlowVariable).nullable().optional(),
  nominal_effort: z.number().nullable().optional(),
  nominal_flow: z.number().nullable().optional(),
  effort_unit: z.string().nullable().optional(),
  flow_unit: z.string().nullable().optional(),
  max_effort: z.number().nullable().optional(),
  max_flow: z.number().nullable().optional(),
  owner: z.string().optional(),
  bound_to: z.array(z.string()).optional(),
}).passthrough();
